import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect } from 'react';
import { MainContentContext } from './MainContent.context';
import { MainContentHeadStyled } from './MainContentHead.styled';
const MainContentHead = forwardRef(({ children, ...props }, ref) => {
    const containerContext = useContext(MainContentContext);
    useEffect(() => {
        if (!containerContext) {
            throw new Error('MainContentHead must be used as a child of MainContent component.');
        }
    });
    return (_jsx(MainContentHeadStyled, { ...containerContext, ...props, ref: ref, children: children }));
});
export { MainContentHead };
